import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const setEstadoFacturacion = (estado) => {
    return {
        type: types.updateEstadosFacturacion,
        payload: estado
    }

}

export const SeleccionarIdSolicitudAuditoria = (id) =>{
    return{
        type:types.seleccionarIdSolicitud,
        payload: id
    }
}

export const seleccionarDetalleFacturacionSinCotizacion = (detalle) =>{
    return{
        type: types.seleccionarDetalleFacturacionSinCotizacion,
        payload: detalle
    }
}

export const desSeleccionarDetalle = () =>{
    return{
        type: types.desSeleccionarDetalleFacturacion
    }
}

export const limpiarMateriales = () =>{
    return{
        type: types.traerMaterialesCotizacionLimpiar
    }
}
export const getComprobantes = (idAfiliado, idSolicitudAuditoria, fechaInicio,fechaFin) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComprasService.GetComprobantes(idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerComprobantesAuditoriaFacturacionSuccess,
                payload: body.comprobantes
            });
            dispatch({type: types.contadoresEstadosAuditoriaSuccess,
                payload:body.cantidades
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerComprobantesAuditoriaFacturacionErrror, })
        handleErrorApi(dispatch, error, "Error al traer los comprobantes", "Ha ocurrido un error. Intente nuevamente")
    }

};

export const getComprobantesPorEstado = (idEstado, idAfiliado, idSolicitudAuditoria, fechaInicio, fechaFin) => async (dispatch) =>{
    dispatch(startSpinner());
    try {
        const response = await ComprasService.GetComprobantesPorEstado(idAfiliado, idSolicitudAuditoria, idEstado, fechaInicio, fechaFin);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerComprobantesPorEstadoSuccess,
                payload: body.comprobantes
            });
            dispatch({type: types.contadoresEstadosAuditoriaSuccess,
                payload:body.cantidades
            })
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerComprobantesPorEstadoError })
        dispatch({type: types.contadoresEstadosAuditoriaError})
        handleErrorApi(dispatch, error, "Error al traer los comprobantes", "Ha ocurrido un error. Intente nuevamente")
    }
} 

export const getEstados = () => async (dispatch) => {
    dispatch(startSpinner());
    try {
        const response = await ComprasService.GetEstados();
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerEstadosAuditoriaFacturacionSuccess,
                payload: body
            });
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({ type: types.traerEstadosAuditoriaFacturacionError, })
        handleErrorApi(dispatch, error, "Error al traer los estados", "Ha ocurrido un error. Intente nuevamente")
    }
}

export const TraerContadoresAuditoria = (idAfiliado,idSolicitud,fechaInicio,fechaFin) => async (dispatch) =>{
    dispatch(startSpinner())
    try{
        const response = await ComprasService.getContadoresAuditoria(idAfiliado,idSolicitud,fechaInicio,fechaFin);
        const body = await  response.json();
        if(response.ok){
            dispatch({type: types.contadoresEstadosAuditoriaSuccess,
            payload:body
        })
        dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        dispatch({type: types.contadoresEstadosAuditoriaError})
        handleErrorApi(dispatch, error, "Error al traer los contadores","Ha ocurrido un error. Intente nuevamente" )
    }
}

export const guardarDetalleFacturacionSinCotizacion = (idExpediente, detalle, idEfectorFacturacion) =>async (dispatch)=>{
    
    dispatch(startSpinner())
    try{
        const data = {
            IdExpediente : idExpediente, 
            ListaProductos : detalle,
            IdEfectorFacturacion : idEfectorFacturacion
        }
        const response = await ComprasService.guardarDetalleFacturacionSinCotizacion(data);
        const body = await response.json(); 
        if(response.ok){
            dispatch(startAlerta("Datos de Facturacion guardados correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch (error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al guardar los datos.", "Ha ocurrido un error. Intente nuevamente")
    }
};
export const guardarDetalleFacturacionConCotizacion = (idExpediente, detalle, idEfectorFacturacion) =>async (dispatch)=>{
    dispatch(startSpinner())
    try{
        const data = {
            IdExpediente : idExpediente, 
            ListaProductos : detalle,
            IdEfectorFacturacion : idEfectorFacturacion
        }
        const response = await ComprasService.guardarDetalleFacturacionConCotizacion(data);
        const body = await response.json(); 
        if(response.ok){
            dispatch(startAlerta("Datos de Facturacion guardados correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch (error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al guardar los datos.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const getMaterialesTramite = (idTramiteCompra) => async (dispatch) =>{
    dispatch(startSpinner())
    try{
        const response = await ComprasService.GetMaterialesTramite(idTramiteCompra);
        const body = await response.json(); 
        if(response.ok){
            dispatch({type: types.traerMaterialesTramiteSuccess,
            payload: body});
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch (error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al traer los materiales.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const AceptarRechazarTramite = (idTramiteCompra, motivoRechazo,estado) => async (dispatch) =>{
    dispatch(startSpinner());
    try{
        var data = {
            MotivoRechazo : motivoRechazo
        }
        const response = await ComprasService.aceptarRechazarTramites(idTramiteCompra, data);
        const body = await response.json(); 
        if(response.ok){
            dispatch(startAlerta(`Tramite ${motivoRechazo === "" ? 'aceptado' : 'rechazado'}`, 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(getComprobantesPorEstado(estado))
        }else{
            throw body; 
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, `Error al ${motivoRechazo === null ? 'aceptar' : 'rechazar'} el tramite.`, "Ha ocurrido un error. Intente nuevamente")
    }
}

export const TraerMaterialesCotizacion = (idEfectorFacturacion, idSolicitud) => async (dispatch)=>{
    dispatch(startSpinner());
    try{
        var data = {
            IdEfectorFacturacion : idEfectorFacturacion, 
            IdSolicitud : idSolicitud
        }
        const response = await ComprasService.GetMaterialesCotizacion(data);
        const body = await response.json(); 
        if(response.ok){
            dispatch({type: types.traerMaterialesCotizacionSuccess,
            payload: body});
            dispatch(finishSpinner());
        }else{
            throw body; 
        }
    }catch(error)
    {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al traer los materiales.", "Ha ocurrido un error. Intente nuevamente")
    }
} 

export const EnviarFacturacionAPagadas = (idTramite, SolicitudPago) => async (dispatch,getState)=>{
    dispatch(startSpinner());
    try{
        var data = {
            solicitudPago : SolicitudPago
        }
        const response = await ComprasService.EnviarAPagadas(idTramite,data);
        const body = await response.json(); 
        //const estado = getState().estadosFacturacionSelect; 
        if(response.ok){
            dispatch(startAlerta('Enviado Correctamente', 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            //dispatch(getComprobantesPorEstado(estado))
        }else{
            throw body; 
        }
    }catch(error)
    {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al traer los materiales.", "Ha ocurrido un error. Intente nuevamente")
    }
} 